import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import App from './App.vue'
import './assets/css/custom.scss'
import customUi from './components/pubilc/index.js'
import exports from './request/exports'
import echarts from 'echarts'
import EZUIKit from 'ezuikit-js'
import variable from './utils/variable'
import Global from './components/Global.vue'

Vue.prototype.$echarts = echarts

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(customUi)
Vue.prototype.$export = exports
Vue.prototype.$eventbus = new Vue()
Vue.prototype.$ezuikit = EZUIKit
Vue.prototype.$rid = Global
Vue.prototype.websocketUrl = variable

new Vue({
  render: (h) => h(App),
  router,
}).$mount('#app')
